module.exports = __webpack_public_path__ + "static/media/Naviguard-Horizontal-Logo.11b2bacb.png";